import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TccApiService {

  constructor(
    private http: HttpClient,
  ) { }

  getCustomThemesStyles(tenantId: number) {
    const url = `https://custom-theme.developerscfw.workers.dev?tenantId=${tenantId}`;
    return this.http.get(url);
  }
}
